import { getUser, getToken } from './service/AuthService';
import { getUserGoal } from './service/GoalService';

import Timer from './Timer';
import ProblematicLogEntry from './ProblematicLogEntry';
import TextExpander from './TextExpander';


import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import closeBttn from './assets/closeBttnSquare.svg';
import nextBttn from './assets/nextBttn.svg';



const logFetchUrl = 'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/problematiclogfetch';

function convertTimestampToDateString(timestamp) {
    const date = new Date(timestamp);
    const options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    };
    const dateString = date.toLocaleDateString('en-US', options)
    return dateString;
}

function convertTimestampToFullDateString(timestamp) {
    const date = new Date(timestamp);
    const options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        timeZoneName: 'short'
    };
    const dateString = date.toLocaleDateString('en-US', options)
    return dateString;
}

const Progress = () => {

    const entries = []
    const [entryHTML, setEntryHTML] = useState(null);
    const [timerHTML, setTimerHTML] = useState(null);
    const [lastSubmitDate, setLastSubmitDate] = useState('');
    const [lastRelapseDate, setLastRelapseDate] = useState('');
    const [lastTitle, setLastTitle] = useState('');
    const [lastDescription, setLastDescription] = useState('');
    const [lastLesson, setLastLesson] = useState('');
    const [lastImpact, setLastImpact] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const user = getUser();
    const token = getToken();
    const goal = getUserGoal();
    const today = new Date()
    const navigate = useNavigate();
    let logHidden = true;

    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [answers, setAnswers] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [showLearningPopup, setShowLearningPopup] = useState(false);
    const [learningContent, setLearningContent] = useState('');


    const relapseHandler = (event) => {
        event.preventDefault();
        navigate('/relapse');

    }

    async function fetchRelapseLog(){
        const requestConfig = {
            headers: {
                'x-api-key': 'mCQrNSvy7X5AUdJlF2ybc3LdEFGndN885kzttyvB'
            }
        }

        const moduleParams = {
            mode: 'default'
        };

        const requestBody = {
            username: user.username,
            token: token,
            module: moduleParams,
        }

        
        axios.post(logFetchUrl, requestBody, requestConfig).then(response => {
            try {
                setLastImpact(response.data.dynamoContent[response.data.dynamoContent.length-1].relapseImpactDescriptionValue)
                setLastLesson(response.data.dynamoContent[response.data.dynamoContent.length-1].relapseImprovementText)
                let lastTitleStart = 'Started on '
                let lastTitleEntryDate = convertTimestampToDateString(Number(response.data.dynamoContent[response.data.dynamoContent.length-1].problematicUseStart))
                let lastTitleTemp = lastTitleStart + lastTitleEntryDate
                setLastTitle(lastTitleTemp)
                setLastRelapseDate(Number(response.data.dynamoContent[response.data.dynamoContent.length-1].problematicUseEnd))
                setLastDescription(response.data.dynamoContent[response.data.dynamoContent.length-1].relapseDescription)  
                if(response.data.dynamoContent.length>=1){
                    setLastSubmitDate(new Date(Number(response.data.dynamoContent[response.data.dynamoContent.length-1].sk)))
                }
                for (let index = response.data.dynamoContent.length - 1; index >= 0; index--) {
                    const entry = response.data.dynamoContent[index];
                    entries.push(<ProblematicLogEntry lastSubmitDate = {new Date(Number(entry.sk)).toString()} lastImpact= {entry.relapseImpactDescriptionValue} lastLesson= {entry.relapseImprovementText} lastDescription= {entry.relapseDescription} lastTitle= {convertTimestampToDateString(Number(entry.problematicUseStart))} />)
                    entries.push(<hr></hr>)
                }
                setEntryHTML(entries)
                setTimerHTML(<div className="item"><Timer lastRelapseDate={lastRelapseDate}/></div>)
            } catch (error) {
                console.log('possibly no entry data yet')
                setEntryHTML(<h3>No Data Yet. As You Use Your Set Back Journal. Your Entries Will Show Here.</h3>)
                setLastTitle(<h4>No Data. Start Using Your Set Back Journal.</h4>)
            }
        }).catch(error => {
            console.error('fetch error: ', error);
            setErrorMessage('Sorry the server is down. Please try again later.');
            if(error.response.status === 403 ){
                setErrorMessage(error.response.data.message);
            }
            else if(error.response.status === 401 ){
                navigate('/login')
            }
            else{
                setErrorMessage('Sorry the server is down. Please try again later.');

            }
        })
    }
    let questionsLearning = [
        {
            question: 'Set Back Log',
            assets: entryHTML,
        },
    ];

    const handleCloseLearningPopup = () => {
        setShowPopup(false);
        setCurrentQuestion(0);
        setAnswers([]);
        document.getElementsByClassName("popupContainer")[0].style.display =  "none"
        document.getElementsByClassName("popupContainer")[0].style.visibility =  "hidden"

    };
    const handleNextQuestion = () => {
        setCurrentQuestion(currentQuestion + 1);
    };

    const handlePreviousQuestion = () => {
        setCurrentQuestion(currentQuestion - 1);
    };

    const handleSubmitLearningClosePopup = () => {
        setShowPopup(false);
        setCurrentQuestion(0);
        setAnswers([]);

    };

    const handleOpenLearningPopup = () => {
        setShowPopup(true);
        document.getElementById('learning-popup').style.display = "block";
        document.getElementsByClassName("popupContainer")[0].style.visibility =  "visible"
        document.getElementsByClassName("popupButtonGroup")[0].style.visibility =  "visible"
    };

    const renderFormLearning = () => {
        try{
            const currentQ = questionsLearning[currentQuestion];
            const { question, options } = currentQ;
            return (
                <div className="formContainer">
                    <div className="button-group" style={{ float: 'right' }}>
                        <button onClick={handleCloseLearningPopup} style={{border:'none'}}> 
                            <img className="closeBttn" src={closeBttn} alt="CloseModalBttn" />
                        </button>
                    </div>
                    <h2 style={{ textAlign: 'center', marginTop: '3rem', marginBottom: '1rem' }}>{question}</h2>
                    <div className="learningTextContent" style={{overflowY: "auto", height: "80%", minHeight:"470px", textAlign: "center"}}> {currentQ.assets} </div>
                    <div className="popupButtonGroup">
                    {currentQuestion > 0 && currentQuestion < questionsLearning.length - 2 ? (
                        <button className="popupNavigationBttn" onClick={handlePreviousQuestion} style={{border:'none', background: 'none'}}>
                            <img className="previousBttn" src={nextBttn} alt="previousBttn" />
                        </button>
                    ) : (
                        null
                    )}
                    {currentQuestion >= 0 && currentQuestion < questionsLearning.length - 3 ? (
                        <button className="popupNavigationBttn" onClick={handleNextQuestion} style={{border:'none', background: 'none', marginLeft: 'auto'}}>
                            <img className="nextBttn" src={nextBttn} alt="nextBttn" />
                        </button>
                    ) : (
                        null
                    )}
                    {currentQuestion === questionsLearning.length - 3 ? (
                        <button id="relapseSubmit" className="popupNavigationBttn" style={{border:'none', background: 'none', marginLeft: 'auto'}}>
                            <img className="nextBttn" src={nextBttn} alt="nextBttn" />
                        </button>
                    ) : (
                        null
                    )}
                    </div>
                </div>
            );
        
        }
        catch{
        }
        
    };

    useEffect(() => {    
        fetchRelapseLog()

    }, []) 
    return (
        <div className="wrapper" style={{ marginTop: '6.5rem', marginLeft: '1rem', marginRight: '1rem'}}>
            <div className="dailyPopup">
                <div className="popupContainer" id="learning-popup"  style={{ display: 'none' }} >{renderFormLearning()}</div>
            </div>
            <div className='donut-parent'>
                <div className="donut"></div>
            </div>
            <div>
                <div>
                    <div>
                        <h2 className="text-center"> Mental Wellness <br/> Progress Overview</h2>
                    </div>
                    
                </div>
                <div>
                    <div>

                        <h4 className="text-center" style={{ marginTop:'3rem' }}> <span className="highlight">Latest Insight:</span> <TextExpander text={lastLesson} /></h4>
                        <h6 className="text-center" style={{ marginTop:'0.5rem', marginBottom:'0.5rem' }}> <span > Current Streak: { lastTitle } </span> </h6>
                        <div className="timer-container">
                        <div className="item">
                            <Timer lastRelapseDate={lastRelapseDate}/>
                        </div>
                    </div>
                    </div>
                    <div> 
                        <div className="homeBttnContainer" style={{ display:'flex', flexDirection:'column', marginTop:"2.5rem" }}>
                            <button className="homeBttn" onClick={handleOpenLearningPopup} >Show Set Back Log</button>
                        </div>
                        <br></br>
                        <br></br>
                    </div>
                </div>
            </div>
            {errorMessage && <p className="message"> { errorMessage } </p>}
        </div>
    )
}

export default Progress;
